import '../../scss/reset.scss';
import '../../scss/main.scss';

import {paCore} from './paCore';

paCore.init();




// WEBPACK FOOTER //
// ./src/js/framework/paEngine.js